import { makeRequestGet, makeRequestGet2, makeRequestPut2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); 
      }
    };
    checkToken();
  });
}

export async function getPayments() {
  let token = await getToken();
  return makeRequestGet2(`payments/`, token);
}
export async function getPayment(id) {
  let token = await getToken();
  return makeRequestGet2(`payments/${id}`, token);
}

export async function putPayment(id, data) {
  let token = await getToken();
  return makeRequestPut2(`payments/${id}`, data, token);
}
